import { render, staticRenderFns } from "./PersonalMembersView.vue?vue&type=template&id=b47d9266"
import script from "./PersonalMembersView.ts?vue&type=script&lang=ts&external"
export * from "./PersonalMembersView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports